export const isPublicMockEnabled = () => {
  return false;
};

export const isAdminLocalModeEnabled = () => {
  return false;
};

export const getFeatureFlagSummary = () => {
  return {
    admin: 'api',
    public: 'api',
  } as const;
};
